<template>
  <AppCodeMirror
    :id="context?.id"
    :aria-labelledby="`${context?.id}_label`"
    :model-value="context._value"
    :lang="context.lang"
    :data-test-id="context.attrs['data-test-id']"
    @update:model-value="input"
  />
</template>

<script lang="ts">
import type { FormKitInputs, FormKitBaseSlots } from '@formkit/inputs'
declare module '@formkit/inputs' {
  interface FormKitInputProps<Props extends FormKitInputs<Props>> {
    code: {
      type: 'code'
      value?: string
    }
  }
  interface FormKitInputSlots<Props extends FormKitInputs<Props>> {
    code: FormKitBaseSlots<Props>
  }
}
</script>

<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
const props = defineProps<{
  context: FormKitFrameworkContext<string> & { lang: CodeInputLangs }
}>()

const input = async (code: string | undefined) => {
  await props.context.node.input(code)
  props.context.node.emit('updateValue', code)
}
</script>
